<template>
  <div style="width: 100%">
    <div class="list-usaha">
      <div
        class="list-usaha-content list-usaha-content__title"
        style="margin-bottom: 0 !important"
      >
        <p v-for="(table, index) in tables" :key="index" :class="table.css">
          {{ table.name }}
        </p>
      </div>
      <div v-for="(list, index) in listInput" :key="index">
        <BlockLabelGray :label="list.label" v-if="list.type == 'label'" />
        <div v-else>
          <div class="list-usaha-content" style="margin-top:5px">
            <p v-for="(table, i) in tables" :key="i" :class="table.css">
              <span v-if="table.input">
                <input
                  style="width: 90%"
                  :type="table.type"
                  v-model="$store.state[storeName][list.inputStore]"
                  v-if="table.type != 'select'"
                  :disabled="disabled"
                />
                <select
                  style="width:90%"
                  name=""
                  id=""
                  v-model="$store.state[storeName][list.optionStore]"
                  v-else
                  :disabled="disabled"
                >
                  <option
                    style="text-align:center"
                    :value="option"
                    v-for="(option, index) in list.options"
                    :key="index"
                    >{{ option }}</option
                  >
                </select>
              </span>

              <span v-else>{{ list[table.type] }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BlockLabelGray from '../../components/forms/label/blockLabel-gray.vue'
export default {
  props: [
    'label',
    'isRequired',
    'tables',
    'storeName',
    'modelName',
    'modalName',
    'mutationName',
    'listInput',
    'disabled',
  ],
  components: { BlockLabelGray },
  data() {
    return {
      labelPlaceholder: 'UPLOAD',
    }
  },
  computed: {},
  methods: {},
}
</script>
